import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { BarChart3, ExternalLink } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { RecentActivity } from "@/app/room/[roomId]/analytics/components/recent-activity";

interface JourneySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  roomId: string;
}

export function JourneySheet({ open, onOpenChange, roomId }: JourneySheetProps) {

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto">
        <SheetHeader>
          <div className="flex items-center justify-between">
            <SheetTitle>Room Activity</SheetTitle>
            <Link href={`/room/${roomId}/analytics`}>
              <Button variant="ghost" size="sm" className="gap-2">
                <BarChart3 className="h-4 w-4" />
                <span className="hidden sm:inline">View Detailed Analytics</span>
                <ExternalLink className="h-3 w-3" />
              </Button>
            </Link>
          </div>
        </SheetHeader>

        <div className="mt-6">
          {open && <RecentActivity roomId={roomId} days={30} maxSessions={10} />}
        </div>
      </SheetContent>
    </Sheet>
  );
} 